// eslint-disable-next-line @typescript-eslint/no-deprecated
export { Alert, alertClassNames, renderAlert_unstable, useAlertStyles_unstable, useAlert_unstable } from './Alert';
// eslint-disable-next-line @typescript-eslint/no-deprecated
export type { AlertProps, AlertSlots, AlertState } from './Alert';
